import React from "react";
import { Quote } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import useReveal from "../../hooks/useReveal";

const AVATARS = [
  "https://images.unsplash.com/photo-1771072427512-74602f4fb49a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBsdXh1cnklMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzgxMTkxMXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1769107260117-ef5fe84b48c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBsdXh1cnklMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzgxMTkxMXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1771072427512-74602f4fb49a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBsdXh1cnklMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzgxMTkxMXww&ixlib=rb-4.1.0&q=85",
];

const Testimonials = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="testimonials"
      ref={ref}
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#070707]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p
            className="reveal font-mono-l text-[11px] text-[#e8d4a8] mb-5 flex items-center justify-center gap-3"
            data-testid="testimonials-eyebrow"
          >
            <span className="w-6 h-px bg-[#e8d4a8]"></span>
            {t.testimonials.eyebrow}
            <span className="w-6 h-px bg-[#e8d4a8]"></span>
          </p>
          <h2
            className="reveal reveal-delay-1 font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            data-testid="testimonials-title"
          >
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.testimonials.items.map((item, i) => (
            <article
              key={i}
              className="reveal relative p-10 border border-white/5 bg-black/60 backdrop-blur-xl card-hover flex flex-col h-full"
              style={{ transitionDelay: `${i * 100}ms` }}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote
                size={28}
                strokeWidth={1}
                className="text-[#e8d4a8]/60 mb-6"
              />
              <p className="font-display italic text-white text-lg leading-relaxed mb-8">
                "{item.quote}"
              </p>

              <div className="mt-auto pt-6 border-t border-white/5 flex items-center gap-4">
                <img
                  src={AVATARS[i % AVATARS.length]}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover border border-[#e8d4a8]/30 grayscale"
                />
                <div>
                  <div className="text-white text-sm">{item.name}</div>
                  <div className="font-mono-l text-[9px] text-white/50 mt-1">
                    {item.role}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
